module.exports = __webpack_public_path__ + "static/media/oberflex-zebranogriscendre-2560x1440.b57103fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranogriscendre-2560x1440.jpg
// module id = 1081
// module chunks = 37